import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { CatalogConnectionsPanel } from '../../../smartLinks/catalog/CatalogConnectionsPanel';
import { CatalogConnectionModals } from '../../../smartLinks/catalog/CatalogConnectionModals';
import { useCatalogConnections } from '../../../smartLinks/catalog/useCatalogConnections';
import { ChannelsSectionHead } from './ChannelsSectionHead';
/* eslint-disable css-modules/no-unused-class -- a shared stylesheet; each part uses its own slice of it */
import styles from './PromoteChannels.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ChannelsDataSectionProps {
  accountId: number;
}

/**
 * The lower part of Channels: the places that give the artist numbers, or that take a song or a
 * video (SoundCloud, YouTube, Spotify for Artists, the distributors). It is the same panel as
 * Catalog → Service connections, with the same dialogs, so a change on one screen shows on both.
 */
const ChannelsDataSectionComponent: React.FC<ChannelsDataSectionProps> = ({ accountId }) => {
  const intl = useIntl();
  const connections = useCatalogConnections({ accountId, isCatalogLoading: false });

  return (
    <section className={styles.dataSection}>
      <ChannelsSectionHead
        title={intl.formatMessage({ id: 'app.sml.promote.channels.data.title', defaultMessage: 'Data channels' })}
        subtitle={intl.formatMessage({
          id: 'app.sml.promote.channels.data.subtitle',
          defaultMessage: 'Where your numbers come from, and where your songs and videos go.',
        })}
      />
      <CatalogConnectionsPanel connections={connections} />
      <CatalogConnectionModals accountId={accountId} connections={connections} />
    </section>
  );
};

export const ChannelsDataSection = TypedMemo(ChannelsDataSectionComponent);
